import {DomainEvent} from './DomainEvent';
import {Coach} from '../resources/Coach';

export class CoachRemoved extends DomainEvent<Coach> {}

export class RefreshCoachRemoved extends CoachRemoved {}
